/**
 * Threeds Resource Client
 * Axios-based API client for 3DS endpoints
 */
export class ThreedsResource {
    constructor(apiClient) {
        this.apiClient = apiClient;
    }
    /**
     * Create a 3DS session
     */
    async createSession(request) {
        return this.apiClient.post('/api/v1/threeds/create-session', request);
    }
}
